import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'sb-progressbar',
  templateUrl: './sb-progressbar.component.html',
  styleUrls: ['./sb-progressbar.component.scss'],
  standalone: false,
})
export class SbProgressbarComponent implements OnInit {
  @Input() classes: string;
  @Input() showPercentageNumber: boolean = true;
  @Input() bigProgress: boolean;
  _width: number;
  get width(): number {
    return this._width;
  }

  @Input('width')
  set width(value: number) {
    this._width = value;
  }

  constructor() {
    this._width = 0;
  }

  ngOnInit() {
    if (this.width === undefined) {
      this.width = 0;
    }
  }
}
